import React, { useEffect } from 'react'
import { InputTextarea } from "primereact/inputtextarea";
import { useFormContext } from 'react-hook-form';
import * as myconst from "../../constants/index"

const StepSeven = ({ handlePrev, handleNext, goOnFirst, isLinear, method, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }
  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['natural_talents', 'struggle_areas', 'obstacles']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }

  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])
  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Are you naturally good at storytelling, teaching, or engaging with an audience?</label>
                <InputTextarea
                  style={{ fontSize: "14px" }}
                  rows={6}
                  className="form-control p-inputtext-lg"
                  {...register("natural_talents", { required: { value: true, message: "Natural Talents is required" } })}
                  onChange={e => { setValue("natural_talents", e.target.value); clearErrors("natural_talents") }}
                  placeholder="Add your natural talents here..." />
                {getFormErrorMessage("natural_talents")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Do you struggle with consistency, confidence, or tech skills?</label>
                <InputTextarea
                  style={{ fontSize: "14px" }}
                  rows={6}
                  className="form-control p-inputtext-lg"
                  {...register("struggle_areas", { required: { value: true, message: "Struggle Areas is required" } })}
                  onChange={e => { setValue("struggle_areas", e.target.value); clearErrors("struggle_areas") }}
                  placeholder="Add your struggle areas here..."
                />
                {getFormErrorMessage("struggle_areas")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">What's holding you back from getting started or leveling up?</label>
                <InputTextarea
                  style={{ fontSize: "14px" }}
                  rows={6}
                  className="form-control p-inputtext-lg"
                  {...register("obstacles", { required: { value: true, message: "Obstacles is required" } })}
                  onChange={e => { setValue("obstacles", e.target.value); clearErrors("obstacles") }}
                  placeholder="Add your obstacles here..." />
                {getFormErrorMessage("obstacles")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={goOnFirst} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{'Next >'}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={handleNext}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepSeven